import './retrait-fonds-modal-content.css'
import React, { useEffect, useState } from "react"
import { Icon } from "semantic-ui-react"
import { investmentService } from "../../../../services/investment-service"
import { AuthenticationState } from "../../../../model/state/authentication-state"
import { ApplicationState } from "../../../../store"
import { useSelector } from "react-redux"
import { FormErrorHeader } from "../../../generic/form-error-header"
import SelectCompteBeneficiairesForm from "../../select-compte-beneficiaires-form/select-compte-beneficiaires-form"
import CompteBeneficiaires from "../../../../model/entities/compte-beneficiaires"
import RetraitFondsForm from "../../retrait-fonds-form/retrait-fonds-form"
import { StatutCompteBeneficiaires } from "../../../../model/entities/statut-compte-beneficiaires"

type Props = {
    walletValue: number,
    onSubmitSuccess: (response: Response) => void
    handleRetraitFonds?: ()=>void
    onCancelAction: () => void
}

enum Steps {
    AccountSelection,
    Amount
}

export function RetraitFondsModalContent({walletValue, onSubmitSuccess, onCancelAction}: Props) {
    const loginProps: AuthenticationState = useSelector<ApplicationState, AuthenticationState>(state => state.authentication)
    const [currentStep, setCurrentStep] = useState<Steps>(Steps.AccountSelection)
    const [accounts, setAccounts] = useState<CompteBeneficiaires[]>([])
    const [selectedAccount, setSelectedAccount] = useState<CompteBeneficiaires | undefined>()
    
    useEffect(() => {
        investmentService.getAllCompteBeneficiairesForUserByUserId(loginProps?.user?.UserId, loginProps.oauth)
        .then((response) => {
            if(response.IsTraitementOk){
                const validatedAccounts = response.Accounts.filter(account => account.StatusCode === StatutCompteBeneficiaires.VALIDE)
                setAccounts(validatedAccounts)
            }
        })
    },[])
                     

    return (
        <>
            <div className="account-amount-container">
                <span className="account-amount-span">{walletValue}€</span>
                <span>
                    <Icon name="money" size="big" />
                    Somme disponible
                </span>
            </div>
            
            <FormErrorHeader 
                message="Vous ne pouvez pas effectuer de retrait car votre compte a été bloqué, veuillez vous rapprocher du support Villyz"
                displayed={loginProps.user?.IsBloque ?? false}
            />

            {currentStep === Steps.AccountSelection && 
                <SelectCompteBeneficiairesForm 
                    accounts={accounts && accounts}
                    onCancelAction={onCancelAction}
                    onValidateAction={(account: CompteBeneficiaires) => {
                        setSelectedAccount(account)
                        setCurrentStep(Steps.Amount)
                    }}
                />
            }
            {currentStep === Steps.Amount && 
                <RetraitFondsForm 
                    onCancelAction={onCancelAction}
                    walletValue={walletValue}
                    onSubmitSuccess={onSubmitSuccess}
                    selectedAccount={selectedAccount!}
                />
            }
        </>
    )
}